module.exports = window["nab"]["segmentationRules"];